import './lib/ofi.min';
import './lib/inview.min';
import {
  hoverFunc
} from './common/_hover';
import {
  mainAnimationFunc,
  contentFadeInFunc,
  layeredAnimation
} from './common/_animation';
import {
  waveFunc
} from './common/_wave';
import {
  windowHeight
} from './common/_resize';
import {
  mainAnimation2022Func,
  backAnimation2022Func,
} from './common/_animation2022';

//* -------------------------------------------------------------------
//通常実行
//------------------------------------------------------------------ */
let setTimer = false;
let loading = $('#loading');

// ロード時
$(window).on('load', function () {
  loading.css('opacity', '0');
  hoverFunc();
  windowHeight();
  backAnimation2022Func();
  mainAnimation2022Func();
});

// リサイズ時
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
  }, 300);
});

///* ------------------------------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//------------------------------------------------------------------ */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
} else {
  // PC時の処理
  uaFlag = 3;
}

/* --------------------------------------------------------------------
IEだけの時
-------------------------------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}